import React, { FC } from 'react';

import { Box, Flex } from '@adsk/alloy-react-box';
import Button from '@adsk/alloy-react-button';

import {
  PRICING_URL,
  AUTOSPECS_TRIAL_MARKETING_URL,
  OFFERING_NAMES,
} from './helpers/const';
import { buttonStyle } from './helpers/styles';
import { SUBSCRIPTION_STATUS } from '../../helpers/const';
import { Subscription, SubscriptionConstruction } from '../../helpers/types';
import { useTranslation } from '../../i18n';

interface TrialModalItemProps {
  userTrial: Subscription | SubscriptionConstruction;
}

const TrialModalItem: FC<TrialModalItemProps> = ({ userTrial }) => {
  const { t } = useTranslation();
  const { daysRemaining, status } = userTrial;
  const offeringCategoryOrName =
    'offeringCategoryName' in userTrial
      ? userTrial.offeringCategoryName
      : userTrial.offeringName;
  const offeringCategory =
    'offeringCategory' in userTrial ? userTrial.offeringCategory : ''; // empty string means the pricing home page
  const nameContainsAutoSpecs = userTrial.offeringName.includes(
    OFFERING_NAMES.AUTOSPECS,
  );

  const daysLeftText =
    daysRemaining > 1
      ? t('MODAL_ITEM_TEXT_EXPIRED_COUNT_MULTIPLE', { daysRemaining })
      : t('MODAL_ITEM_TEXT_EXPIRED_COUNT_SINGLE', { daysRemaining });

  return (
    <Flex
      paddingBottom="16px"
      flexDirection="row"
      justifyContent="space-between"
    >
      <div>
        <Box typography="bodyMedium">{offeringCategoryOrName}</Box>
        <Box
          typography="bodyMedium"
          color={
            daysRemaining !== null && daysRemaining < 3
              ? 'red500'
              : 'charcoal900'
          }
        >
          {status === SUBSCRIPTION_STATUS.ACTIVE
            ? daysLeftText
            : t('MODAL_ITEM_TEXT_EXPIRED')}
        </Box>
      </div>
      <Button
        data-testid="TrialModalItem_button"
        as="a"
        target="_blank"
        href={
          nameContainsAutoSpecs
            ? AUTOSPECS_TRIAL_MARKETING_URL
            : `${PRICING_URL}/${offeringCategory}`
        }
        style={buttonStyle}
        variant={Button.VARIANTS.PRIMARY}
      >
        {t('MODAL_ITEM_TEXT_BUTTON_TEXT')}
      </Button>
    </Flex>
  );
};

TrialModalItem.displayName = 'TrialModalItem';

export default TrialModalItem;
